import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  useTheme,
} from "@mui/material";

interface ManageBackupsPartsProps {
  fileNum: number;
  fileSize: string;
}

export const ManageBackupsParts: React.FC<ManageBackupsPartsProps> = ({
  fileNum,
  fileSize,
}) => {
  const theme = useTheme();

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableBody>
            {/* 総ファイル数 */}
            <TableRow>
              <TableCell
                component="th"
                scope="row"
                align="center"
                size="small"
                sx={{
                  fontSize: "0.8rem",
                  fontWeight: "fontWeightRegular",
                  backgroundColor: theme.palette.custom.tableHeader,
                  color: "white",
                  px: 1,
                  py: 0.3,
                }}
              >
                総ファイル数
              </TableCell>
              <TableCell
                sx={{
                  fontSize: "0.8rem",
                  fontWeight: "fontWeightRegular",
                  backgroundColor: theme.palette.custom.row,
                }}
                size="small"
              >
                {fileNum}
              </TableCell>
            </TableRow>

            {/* 総バックアップサイズ*/}
            <TableRow>
              <TableCell
                component="th"
                scope="row"
                align="center"
                size="small"
                sx={{
                  fontSize: "0.8rem",
                  fontWeight: "fontWeightRegular",
                  backgroundColor: theme.palette.custom.tableHeader,
                  color: "white",
                  px: 1,
                  py: 0.3,
                }}
              >
                総バックアップサイズ
              </TableCell>

              <TableCell
                size="small"
                sx={{
                  fontSize: "0.8rem",
                  fontWeight: "fontWeightRegular",
                  backgroundColor: theme.palette.custom.row,
                }}
              >
                {fileSize}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
export default ManageBackupsParts;
